import { fetchEventSource } from '@microsoft/fetch-event-source'
import { getGateWayToken } from '@/services'
import { aiTalk } from '@/api/ai'
import { sleep, signature } from '@/utils/index.js'
import Typed from '@/utils/typed.js'

const env = require('../../env/index.js')

const { APPID, MERCHANTID } = env
// import md from '@/utils/md.js'

export default class AiChatUtil {
    /**
     * @param {*}
     * @memberof AiChatUtil
     */
    constructor(options) {
        this.stream = options.stream
        this.useTyped = options.useTyped
        this.message = options.message
        this.count = 0 // 计数器：当前打了几条字
        this.streamTimeoutCount = 0 // 流超时计数
        this.authorizationOverdueCount = 0
        this.SLBROWSER_PC_AI_ASSIST_AUTHORIZATION = 'slbrowser_pc_ai_assist_authorization'
        this.typed = null
        this.strings = []
        this.words = [`推荐搜索词：\n\n`, `推荐搜索词：\n`, `推荐搜索词：`]
        this.isTyped = false // 是否正在打字(数组单条)
        this.isTyping = false // 是否正在打字(打字或等待打字)
        this.isEnd = false
        this.isLoading = false
        this.aiTalkAbortController = null
        this.authorizeApplyAbortController = null
        this.authorization = ''
        this.finishReason = 'normal'

        this.animationStringArray = options.result // 指向调用者的响应数据
        // this.animationStringArray = []
        this.onComplete = options.onComplete // 打字过程中
        this.typedFinish = options.typedFinish // 打字结束
        this.requestSuccess = options.requestSuccess // 请求成功
        this.requestError = options.requestError // 请求失败
        this.requestFinish = options.requestFinish // 请求完成
        this.requestEnd = options.requestEnd // 请求结束
        // this.animationStringArray = new Proxy([], {
        //     set: (target, property, value, receiver) => {
        //         // 监听数组的变化，执行你的逻辑
        //         console.log(`Array changed: Setting ${property} to ${value}`)
        //         // 执行默认行为：设置属性值
        //         return Reflect.set(target, property, value, receiver)
        //     },
        //     get(value) {
        //         console.log(value)
        //     }
        // })
        this.initAuthorization()
    }

    stopAnswer() {
        if (this.aiTalkAbortController) {
            this.aiTalkAbortController.abort()
            this.aiTalkAbortController = null
        }
        if (this.authorizeApplyAbortController) {
            this.authorizeApplyAbortController.abort()
            this.authorizeApplyAbortController = null
        }
        if (this.isLoading) {
            this.isLoading = false
            this.isEnd = true
            this.handleResponse({
                is_discard: true,
                content: '已停止回答',
            })
            return
        }
        if (this.isTyping || this.isTyped) {
            this.isEnd = true
            this.typed && this.typed.stop()
            return
        }
    }

    handleComplete() {
        if (this.onComplete) {
            const result = ''
            // if (this.animationStringArray.join('').length <= 0) {
            //     result = md.render(this.animationStringArray.join(''))
            // } else {
            //     result = md.render(this.animationStringArray.join('') + ' |')
            // }
            this.onComplete(result)
        }
    }

    typedCallback(response) {
        console.log('typedCallback', response)
        if (this.typedFinish) {
            this.typedFinish()
        }
    }

    // 打字
    typedFn(response) {
        if (!this.useTyped) return
        if (this.isTyped) return
        this.isTyped = true
        this.isTyping = true
        this.typed = null
        this.typed = new Typed(this.animationStringArray, {
            strings: [this.strings[this.count]],
            typeSpeed: 40,
            onBegin: () => { },
            onStop: arrayPos => {
                console.log('onStop 停止打字 ', arrayPos, this)
                this.isTyped = false
                this.typed = null
                this.typedCallback(response)
            },
            onComplete: async () => {
                this.handleComplete()

                this.isTyped = false
                this.count++
                if (this.strings.length > this.count) {
                    this.typedFn(response)
                    // 流有更新，清除流超时次数
                    if (this.streamTimeoutCount > 0) {
                        this.streamTimeoutCount = 0
                    }
                    return
                }
                // 等待数据过来
                if (!this.isEnd && this.strings.length === this.count) {
                    /**
                     * 1. 这里需等待返回，暂时添加一些空数据，避免无法取到 [this.strings[this.count]] 报错
                     * 2. 200ms后如果有数据会跳出此if语句,无进行超时记录，超时10s后停止打字
                     */
                    await sleep(200)
                    // 判断是否停止回答，停止回答后，程序唤醒不在执行后续操作
                    if (!this.typed) return
                    console.log('Waiting for stream...')
                    this.strings.push('')

                    // 更新流超时次数
                    this.streamTimeoutCount++
                    if (this.streamTimeoutCount >= 50) {
                        console.log('流超时了，停止打字 ')
                        this.isEnd = true
                        this.isTyped = false
                        this.typedCallback(response)
                        this.typed = null

                        // 清空流超时次数
                        this.streamTimeoutCount = 0
                        return
                    }
                    this.typedFn(response)
                    return
                }
                // 数据返回结束
                if (this.isEnd && this.strings.length === this.count) {
                    this.typedCallback(response)
                }
            },
            preStringTyped: arrayPos => {
                console.log('preStringTyped', arrayPos)
            },
        })
    }

    handleResponse(response) {
        // 网页总结(处理搜索关键词)
        this.words.forEach(word => {
            if (response.content.includes(word)) {
                // 前半段
                const beforeString = response.content.split(word)[0]

                // 切割符号
                let splitSymbol = ''
                let afterString = response.content.split(word)[1]
                if (afterString) {
                    afterString = response.content.split(word)[1].replace(/。/, '')
                    if (afterString.includes('、')) {
                        splitSymbol = '、'
                    } else if (afterString.includes('；')) {
                        splitSymbol = '；'
                    } else if (afterString.includes('\n\n')) {
                        splitSymbol = '\n\n'
                    } else if (afterString.includes('\n')) {
                        splitSymbol = '\n'
                    }

                    // 后半段
                    let newAfterString = ''
                    if (splitSymbol) {
                        newAfterString = afterString
                            .split(splitSymbol)
                            .map(item => {
                                item = item.replace(/\*/g, '')
                                item = item.replace(/\d+(\.)/g, '')
                                item = item.trim()
                                item = ` ${item} `
                                return `<a class="sch-keywords">${item}</a>`
                            })
                            .join('')
                    } else {
                        newAfterString = `<a class="sch-keywords">${afterString}</a>`
                    }
                    const html = `<span class="f-fs1 m-sch-lst"><span class="lt">相关搜索</span><span class="rt">${newAfterString}</span></span>`
                    const content = beforeString + html
                    response.content = content
                }
            }
        })

        // 完善接口，对字符串进行切割
        if (response.stream === 'false') {
            const arr = response.content
                .split('<br><br>')
                .map((item, index, array) => {
                    if (index < array.length - 1) {
                        item = `${item}<br><br>`
                    }
                    return item
                })
            this.strings = arr
        } else {
            this.strings.push(response.content)
        }

        this.typedFn(response)
    }

    handleRequest() {
        this.isLoading = true
        this.aiTalkAbortController = null
        this.aiTalkAbortController = new AbortController()
        const messages = [
            {
                role: 'user',
                content: this.message,
            },
        ]
        const body = {
            appId: APPID,
            merchantId: MERCHANTID,
            sign_type: 'RSA2',
            timestamp: Date.now(),
            stream: this.stream,
            messages: JSON.stringify(messages),
            // promptCode: '1724148426518',
        }
        const sign = Object.keys(body)
            .sort()
            .filter(k => body[k])
            .map(k => `${k}=${body[k]}`)
            .join('&')
        body.sign = signature(sign)

        const _this = this
        fetchEventSource(aiTalk(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.authorization,
            },
            openWhenHidden: true,
            body: JSON.stringify(body),
            signal: this.aiTalkAbortController.signal,
            async onopen(response) {
                console.log('onopen', response)
                if (response.ok) {
                    if (_this.authorizationOverdueCount > 0) {
                        _this.authorizationOverdueCount = 0
                    }
                    if (_this.requestSuccess) {
                        _this.requestSuccess(_this.finishReason)
                    }
                    return
                } else {
                    if (response.status === 401) {
                        console.warn('401', _this.authorizationOverdueCount)
                        const slbrowser_pc_ai_assist_authorization_cookie = `${_this.SLBROWSER_PC_AI_ASSIST_AUTHORIZATION}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`
                        document.cookie = slbrowser_pc_ai_assist_authorization_cookie
                        if (_this.authorizationOverdueCount === 0) {
                            _this.authorizationOverdueCount += 1
                            _this.authorizeApplyAbortController = null
                            _this.authorizeApplyAbortController = new AbortController()
                            // const token = await getLoginStatus()
                            const loginInfo = await window.pcmjssdk.commonMethod.getLoginInfo()
                            console.log('loginInfo', loginInfo)
                            _this.LIDToken = loginInfo && loginInfo.token || ''
                            _this.authorization = await getGateWayToken({}, _this.authorizeApplyAbortController)
                            console.log('authorization', _this.authorization)
                            if (_this.authorization) {
                                console.warn('获取权限成功', _this.authorization)
                                return _this.handleRequest()
                            }
                        }
                    }
                    _this.isEnd = true
                    _this.isLoading = false
                    _this.handleResponse({
                        is_discard: true,
                        content: '很抱歉，当前遇到了一些问题，请稍后重试。',
                    })
                    if (_this.requestError) {
                        _this.requestError(_this.finishReason, '很抱歉，当前遇到了一些问题，请稍后重试。')
                    }
                }
            },
            onmessage(msg) {
                if (msg?.data) {
                    const res = JSON.parse(msg.data)
                    if (_this.requestFinish) {
                        _this.requestFinish(res)
                    }
                    const result = res?.data?.result
                    const isEnd = res?.data?.isEnd
                    _this.finishReason = res?.data?.finishReason
                    _this.isLoading = false
                    if (isEnd === 'true') {
                        _this.isEnd = true
                        _this.aiTalkAbortController.abort()
                        if (_this.requestEnd) {
                            _this.requestEnd(_this.finishReason)
                        }
                    }
                    if (_this.useTyped) {
                        _this.handleResponse({
                            is_discard: false, // 是否丢弃
                            content: result,
                        })
                    }
                }
            },
            onclose() {
                console.log('onclose')
            },
            onerror(err) {
                console.log('onerror', err)
                _this.isEnd = true
                _this.isLoading = false
                _this.handleResponse({
                    content: '很抱歉，当前遇到了一些问题，请稍后重试。',
                    is_discard: true,
                })
                if (_this.requestError) {
                    _this.requestError(_this.finishReason, '很抱歉，当前遇到了一些问题，请稍后重试。')
                }
                return 1000 * 60 * 60 * 24
            },
        })
    }

    async initAuthorization() {
        this.authorization = document.cookie.replace(/(?:(?:^|.*;\s*)slbrowser_pc_ai_assist_authorization\s*=\s*([^;]*).*$)|^.*$/, '$1',)
        if (!this.authorization) {
            this.authorizeApplyAbortController = new AbortController()
            this.authorization = await getGateWayToken(
                {},
                this.authorizeApplyAbortController,
            )
        }

        this.handleRequest()
    }

    Init() { }

    Destory() {
        this.count = 0
        this.streamTimeoutCount = 0
        this.typed = null
        this.strings = []
        this.isTyped = false
        this.isTyping = false
        this.isEnd = false
        this.isLoading = false
        // this.authorization = ''
        this.animationStringArray = []
        if (this.aiTalkAbortController) {
            this.aiTalkAbortController.abort()
            this.aiTalkAbortController = null
        }
        if (this.authorizeApplyAbortController) {
            this.authorizeApplyAbortController.abort()
            this.authorizeApplyAbortController = null
        }
    }
}
